<template>
<div>
    <div class="rightFilterWrap buyingOption" @click="changeActive" :class="{ 'showFilter' : isActive }">

			<div class="rightFiterContent">
				<div class="filterHeading">
					{{ this.items.length }} Sellers Available
					<a href="javascript:void(0)" @click="changeActive" class="filterClose float-right mr-3 text-dark"> &#10005;</a>
				</div>
				<div
					class="page_loader"
					id="r_page_loader" 
					v-show="false"				>
					<loading-icon class="loading-icon newLoader" name="ball-clip-rotate-multiple" color="#ba2126" scale="1"></loading-icon>
					<!-- <Loader />   removed ondition to hide loader from product lisiting  this.$root.page_loader == true --> 
				</div>
				<div class="filterData" v-if="!this.$root.page_loader">
					<div class="filterDataScroll">
						<div class="row m-0">
							<div class="col-12 mb-2 p-0" v-for="(store, i) in items" :key="i" >
								<router-link class=" moreStoreRow" :to="{name:'detail', params:{ pro_id: store.id_product, pro_url_key:store.url_key},
                                                query: { store: store.store,
                                                id:store.id_product
                                                 }
                                                }">
								 
									<!-- <img class="storeLogo img-fluid" :src="store.logo" alt=""> -->
								<div class="d-inline-block w-100">
									<p class="price float-left m-0"><span>{{store.selling_price | 
										formatMoney}}</span></p>
									<p class="add-to-cart btn float-right m-0">
										<!-- <i class="fa fa-eye mr-2"></i> -->
										View Product
									</p>
								</div> 
								<p class="nameStore m-0"> Sold By: <span>{{ store.name }}</span> </p> 

								<div v-for="(size, j) in store.product_variation" :key='j'>
									{{size}}
								</div>						
								
								
								<!-- <router-link :to="{name:'detail', params:{ pro_id: store.id_product, pro_url_key:store.url_key}, query: { store: store.store, id:store.id_product}}" class="add-to-cart btn" >
									<i class="fa fa-eye mr-2" aria-hidden="true"></i> View
								</router-link> -->
								</router-link>
							</div> 
						
						</div> 
					</div>
					<!-- <div class="filterButton">
						<button class="sideFilterClear">Clear List</button>
						<button class="sideFilterMore">See Nearby Stores</button>
					</div> -->
				</div>
			</div>
		</div>
		</div>
</template>
<script>
 
export default {
   props: ["items", "isActive"],
   methods:{
       changeActive () {
       this.$parent.$emit('changeIsActive', false);
	},
	
	
	formatPrice(value, precision = false) {
				let val;			

				if (precision) 
					val = (value / 1).toFixed(2).replace(",", ",");
				else 
					val = (value / 1).toFixed(0).replace(",", ",");

				return `<span>&#8377;</span> ${val
					.toString()
					.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
					.replace(".00", "<small>.00</small>")} `;
			},
   },
   beforeMount(){
		document.addEventListener("keyup", evt => {
			if (evt.keyCode == 27) {
				// alert('adsfa');
				this.$parent.$emit('changeIsActive', false);
			}
		});
	},
}
</script>

<style>
	@media screen and (max-width: 767px) {
		/* .rightFilterWrap{
			left: 130%;
		} */
		.rightFiterContent .filterHeading{
			font-size: 20px;
		}
		.rightFiterContent{
		    max-width: 80%;
		}
	}
</style>